import { syncConsentImports } from './consentImports';

export const Sagas = [syncConsentImports];
